var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-layout-headline-with-tabs',{attrs:{"tabs":_vm.tabs}},[_vm._v(_vm._s(_vm.$t("users")))])}
var staticRenderFns = []

export { render, staticRenderFns }